import { render, staticRenderFns } from "./Feet.vue?vue&type=template&id=bab4d88c"
import script from "./Feet.vue?vue&type=script&lang=js"
export * from "./Feet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports